import { useState } from 'react';

export const useDisclosure = (defaultOpen = false) => {
    const [open, setOpen] = useState(defaultOpen);

    const handleClose = () => setOpen(false);
    const handleOpen = () => setOpen(true);
    const toggle = () => setOpen((prev) => !prev);

    return { open, handleClose, handleOpen, toggle };
};
